// Colour-blind accessible palettes for the RSVP pivot character.
// Each palette has a dark-mode pivot/glow and a `pivotLight`/`glowLight`
// counterpart darkened for the cream light-mode bg (#F5F3EE). Pure white
// becomes black for Achromatopsia — the simulation is "maximum luminance
// contrast", which inverts when the page background inverts.
export const PALETTES = {
  default:       { name: "Default",       pivot: "#ff6b6b", glow: "255,107,107", pivotLight: "#C92020", glowLight: "201,32,32",  desc: "Standard red pivot — optimised for typical colour vision.", icon: "◉" },
  deuteranopia:  { name: "Deuteranopia",  pivot: "#4da6ff", glow: "77,166,255",  pivotLight: "#1E6BC0", glowLight: "30,107,192", desc: "Green-blind — red/green appears as blue/gold. Pivot shifts to blue.", icon: "◎" },
  protanopia:    { name: "Protanopia",    pivot: "#f5c542", glow: "245,197,66",  pivotLight: "#8E5A00", glowLight: "142,90,0",   desc: "Red-blind — reds appear dark/muddy. Pivot shifts to amber.", icon: "◎" },
  tritanopia:    { name: "Tritanopia",    pivot: "#ff8a65", glow: "255,138,101", pivotLight: "#B04020", glowLight: "176,64,32",  desc: "Blue-blind — blue/yellow confused. Pivot uses warm orange.", icon: "◎" },
  achromatopsia: { name: "Achromatopsia", pivot: "#ffffff", glow: "255,255,255", pivotLight: "#000000", glowLight: "0,0,0",      desc: "Total colour blindness — relies entirely on luminance contrast.", icon: "○" },
};

// Returns a palette object with `pivot` and `glow` resolved for the given theme.
export function resolvePalette(p, mode) {
  if (mode === "light" && p.pivotLight) {
    return { ...p, pivot: p.pivotLight, glow: p.glowLight };
  }
  return p;
}
